import {interpolateColorRBG} from "../../util/color";
import {manager} from "../weather_manager";
import {updateCheckboxSettingState} from "../../settings/settings_common";

export function getUVIColor(uv_value) {

    const gradientStops = [
        {stop: 0, color: {r: 75, g: 192, b: 102}},
        {stop: 4, color: {r: 255, g: 205, b: 86}},
        {stop: 6, color: {r: 255, g: 159, b: 64}},
        {stop: 8, color: {r: 255, g: 99, b: 64}},
        {stop: 12, color: {r: 252, g: 53, b: 76}} // Ensure that the last stop covers the max value
    ];

    if (uv_value >= 12) {
        return 'rgb(252, 53, 76, 0.8)';
    }

    for (let i = 0; i < gradientStops.length - 1; i++) {
        if (uv_value >= gradientStops[i].stop && uv_value < gradientStops[i + 1].stop) {
            const factor = (uv_value - gradientStops[i].stop) / (gradientStops[i + 1].stop - gradientStops[i].stop);
            let c = interpolateColorRBG(gradientStops[i].color, gradientStops[i + 1].color, factor);
            return `rgba(${c.r}, ${c.g}, ${c.b}, 0.8)`
        }
    }
}


export function updateUVIndex() {
    let uviCheckBox = document.querySelector("#uvi_enabled_form input");
    updateCheckboxSettingState(uviCheckBox);

    const uvi_cont = document.getElementById("uvi_container");

    if (uviCheckBox.checked && manager.currentWeather.uvi > 2.7) {
        uvi_cont.style.background = getUVIColor(manager.currentWeather.uvi);
        uvi_cont.querySelector(".cur-uv-value").textContent = Math.round(manager.currentWeather.uvi);
        uvi_cont.style.display = "flex";
    } else {
        uvi_cont.style.display = "none";
    }
}